import { trackTrendingHomeClick } from "./tracking.js";

type TrackingLink = HTMLAnchorElement & {
	dataset: DOMStringMap & {
		adId: string;
		adName: string;
		position: string;
	};
};

function findTrackingLink(event: Event): TrackingLink | null {
	const target = event.target;
	return target instanceof Element ? (target.closest("[data-trending-home]") as TrackingLink | null) : null;
}

function handleClick(event: Event) {
	const link = findTrackingLink(event);
	if (link) {
		trackTrendingHomeClick({
			id: link.dataset.adId,
			name: link.dataset.adName,
			position: link.dataset.position,
			url: link.href,
		});
	}
}

function handleAuxClick(event: MouseEvent) {
	if (event.button === 1) {
		handleClick(event);
	}
}

const podlet = document.querySelector("qasa-popular-ads-podlet");
const root =
	podlet?.shadowRoot?.querySelector("#qasa-popular-ads-podlet-root") ??
	document.querySelector("#qasa-popular-ads-podlet-root");

root?.addEventListener("click", handleClick);
root?.addEventListener("auxclick", handleAuxClick as EventListener);
